/**
 * Created by vladislav on 2/28/2024
 */

const Activities = function () { 
    this.lastActivitySent = 0;

    this.interval = Activities.INVERVALS[connector.info.source];
};

Activities.prototype.canSend = function (activityType) {
    if (this.interval && Date.now() - this.lastActivitySent < this.interval) {
        return false;
    }

    const config = Activities.CONFIG[activityType];

    return config.probability > Math.random();
};

Activities.prototype.send = function (activityType, data) {
    if (connector.platform.oneOf(connector.VK)) {
        this._sendVkActivity(activityType, data);
        return;
    }

    if (!this.canSend(activityType)) {
        return;
    }

    const config = Activities.CONFIG[activityType];
    const message = PseudoRandom.GET().mathChoose(config.messages);

    const params = {
        title: Messages.get(message.title),
        body: Messages.get(message.body, data),
        link: cleverapps.config.deployment
    };

    connector.social.sendActivity(params, (code) => {
        if (code === cleverapps.CODE_SUCCEED) {
            this.lastActivitySent = Date.now();
        }
    });
};

Activities.prototype._sendVkActivity = function (activityType, data) {
    if (activityType !== Activities.TYPES.LVL_PASSED) {
        return;
    }

    let activityData;
    if (data.score && Math.random() < 0.5) {
        activityData = {
            activityId: 2,
            value: data.score
        };
    } else {
        activityData = {
            activityId: 1,
            value: data.levelNo
        };
    }

    connector.social.sendActivity(activityData, () => {});
};

Activities.INVERVALS = {
    draugiem: cleverapps.parseInterval("1 day")
};

Activities.TYPES = {};
Activities.TYPES.LVL_PASSED = 0;

Activities.CONFIG = {};

Activities.CONFIG[Activities.TYPES.LVL_PASSED] = {
    probability: 0.25,
    messages: [{
        title: "Activity.PassLevel.title",
        body: "Activity.PassLevel.body1"
    }, {
        title: "Activity.PassLevel.title",
        body: "Activity.PassLevel.body2"
    }, {
        title: "Activity.PassLevel.title",
        body: "Activity.PassLevel.body3"
    }
    ]
};
